var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-video',{ref:"videoRef",staticStyle:{"box-shadow":"0 3px 10px rgb(0 0 0 / 0.2)"},attrs:{"sources":_vm.video.sources,"options":_vm.video.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }